// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pay-management .charge-item-maintain-dialog[data-v-40936448]  .el-scrollbar__wrap {\n  overflow-x: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
